(function () {
  function setExpanded(gallery, card, expanded) {
    gallery.querySelectorAll('[data-builder-card]').forEach(function (item) {
      var isOpen = expanded && item === card;
      item.classList.toggle('is-expanded', isOpen);
      item.querySelectorAll('[data-builder-toggle]').forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  function bindGallery(gallery) {
    if (!gallery || gallery.dataset.bound === 'true') return;
    gallery.dataset.bound = 'true';

    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (canHover) {
      gallery.querySelectorAll('[data-builder-card]').forEach(function (card) {
        card.addEventListener('mouseenter', function () {
          if (card.classList.contains('is-dismissed')) return;
          setExpanded(gallery, card, true);
        });
        card.addEventListener('mouseleave', function () {
          card.classList.remove('is-dismissed');
          setExpanded(gallery, card, false);
        });
        card.addEventListener('focusin', function () {
          if (card.classList.contains('is-dismissed')) return;
          setExpanded(gallery, card, true);
        });
        card.addEventListener('focusout', function (event) {
          if (!card.contains(event.relatedTarget)) setExpanded(gallery, card, false);
        });
        card.addEventListener('click', function (event) {
          var closeButton = event.target.closest('.builder-club__toggle--close');
          if (!closeButton || !card.contains(closeButton)) return;
          card.classList.add('is-dismissed');
          setExpanded(gallery, card, false);
          closeButton.blur();
        });
      });
      return;
    }

    gallery.addEventListener('click', function (event) {
      var button = event.target.closest('[data-builder-toggle]');
      if (!button || !gallery.contains(button)) return;

      var card = button.closest('[data-builder-card]');
      if (!card) return;

      setExpanded(gallery, card, !card.classList.contains('is-expanded'));
    });
  }

  // Desktop: pin the section when it reaches the top of the viewport and use the page scroll
  // to scroll the gallery. Once the gallery reaches its end, the page continues normally.
  function bindPin(root) {
    var pin = root.querySelector('[data-builder-pin]');
    var gallery = root.querySelector('[data-builder-gallery]');
    if (!pin || !gallery || root.dataset.pinBound === 'true') return;
    root.dataset.pinBound = 'true';

    var desktop = window.matchMedia('(min-width: 750px)');
    var distance = 0;
    var pinTop = 0;
    var frame = null;

    function sync() {
      frame = null;
      if (!distance) return;
      var progress = (pinTop - root.getBoundingClientRect().top) / distance;
      gallery.scrollTop = Math.round(Math.max(0, Math.min(1, progress)) * distance);
    }

    function requestSync() {
      if (frame === null) frame = window.requestAnimationFrame(sync);
    }

    function measure() {
      distance = desktop.matches ? Math.max(0, gallery.scrollHeight - gallery.clientHeight) : 0;
      root.classList.toggle('builder-club--pinned', distance > 1);

      if (distance <= 1) {
        distance = 0;
        root.style.removeProperty('--builder-pin-distance');
        root.style.removeProperty('--builder-pin-top');
        return;
      }

      // If the content is taller than the viewport, pin when its bottom reaches the viewport bottom.
      pinTop = Math.min(0, window.innerHeight - pin.offsetHeight);
      root.style.setProperty('--builder-pin-distance', distance + 'px');
      root.style.setProperty('--builder-pin-top', pinTop + 'px');
      sync();
    }

    // Card heights change as lazy images load, so re-measure whenever the gallery content resizes.
    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(measure);
      observer.observe(gallery);
      gallery.querySelectorAll('[data-builder-card]').forEach(function (card) {
        observer.observe(card);
      });
    }

    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', measure);
    desktop.addEventListener('change', measure);
    measure();
  }

  function init(root) {
    if (!root) return;
    bindGallery(root.querySelector('[data-builder-gallery]'));
    bindPin(root);
  }

  function initAll() {
    document.querySelectorAll('[data-builder-club]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-builder-club]') || event.target);
  });

  if (document.readyState !== 'loading') initAll();
})();
